import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "lightsaber-kiadimundi-aotc",
  name: `Lightsaber\nKi-Adi-Mundi Ep2`,
  nameFormatted: {
    primary: "Lightsaber",
    secondary: "Ki-Adi-Mundi Ep2",
  },
  origin: "Star Wars: Episode II – Attack of the Clones",

  category: replicaCategories.starWars,

  versions: [Version1],
};

export default data;
